import VueJwtDecode from 'vue-jwt-decode'
import { useCookies } from "vue3-cookies"

export default () => {
  const { cookies } = useCookies()
  
  return cookies.get('jwt') ? VueJwtDecode.decode(cookies.get('jwt')) : null
}
